export const deliveryRoutes = [
  {
    path: "/purchase-order/:id/details",
    name: "purchase-order.details",
    component: () => import("@/views/delivery/ShipmentDetailsPage.vue"),
    meta: {
      title: "Purchase Order Details",
      printersList: true,
      ability: { action: "read", subject: "DeliveryPallet" },
    },
  },
  {
    path: "/purchase-order/:id/summary",
    name: "purchase-order.summary",
    component: () => import("@/views/delivery/ShipmentSummaryPage.vue"),
    meta: {
      title: "Purchase Order Summary Report",
      printersList: true,
      ability: { action: "read", subject: "DeliveryOrder" },
    },
  },
  {
    path: "/purchase-order/:id/summary/view/:orderStatus",
    name: "purchase-order.summary.view",
    component: () => import("@/views/delivery/ShipmentSummaryPage.vue"),
    meta: {
      title: "Purchase Order Summary",
      printersList: true,
      ability: { action: "update", subject: "DeliveryOrder" },
    },
  },
  {
    path: "/purchase-order/:id/shipment/create/",
    name: "purchase-order.shipment.create",
    component: () => import("@/views/delivery/ShipmentCreate.vue"),
    meta: {
      title: "Purchase Order Shipment Create",
      printersList: true,
      ability: { action: "create", subject: "DeliveryPallet" },
    },
  },
  {
    path: "/purchase-order/:id/shipment/:shipmentId/pallet/create/",
    name: "purchase-order.pallet.create",
    component: () =>
      import("@/views/delivery/ShipmentPalletCreateForShipment.vue"),
    meta: {
      title: "Purchase Order Pallet Create",
      printersList: true,
      ability: { action: "create", subject: "DeliveryPallet" },
    },
  },

  {
    path: "/purchase-order/:id/pallet/create/",
    name: "purchase-order.pallet.create.multi-shipment",
    component: () => import("@/views/delivery/ShipmentPalletCreate.vue"),
    meta: {
      title: "Purchase Order Pallet Create",
      printersList: true,
      ability: { action: "create", subject: "DeliveryPallet" },
    },
  },
  {
    path: "/purchase-order/:id/shipment/:shipmentId/pallet/:palletId/scan",
    name: "purchase-order.pallet.scan",
    component: () => import("@/views/delivery/ShipmentOrderScan.vue"),
    meta: {
      title: "Purchase Order Scan",
      printersList: true,
      ability: { action: "read", subject: "DeliveryPallet" },
    },
  },
  {
    path: "/purchase-order/:id/bulk/:bulkId",
    name: "bulk-receive.progress",
    component: () =>
      import(
        "@/views/delivery/components/shipmentBulk/ShipmentBulkReceiveProgressPage.vue",
      ),
    meta: {
      title: "Bulk Receive Progress",
      printersList: true,
      ability: { action: "read", subject: "DeliveryPallet" },
    },
  },
];
